import React, { useState } from 'react'
import './Notification.css'
import PropTypes from 'prop-types'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

//svg
import SvgThumbUp from '../../svgIcons/SvgThumbUp'
import SvgExpiry from '../../svgIcons/SvgExpiry'
import SvgExclamationMark from '../../svgIcons/SvgExclamationMark'
import SvgFeather from '../../svgIcons/SvgFeather'
import SvgCloud from '../../svgIcons/SvgCloud'

//Redux
import { useDispatch } from 'react-redux'
import { deleteNotification } from '../../redux'

//Bootstrap
import Button from 'react-bootstrap/Button'

function Notification(props) {
  const { handleNotificationClose, userId, notification } = props
  const history = useHistory()
  const [disabled, setDisabled] = useState(false)
  const dispatch = useDispatch()

  const onNotificationClick = (id) => {
    history.push('/viewDocumentDetails/' + id)
    handleNotificationClose()
  }

  const onNotedClick = () => {
    setDisabled(true)
    dispatch(deleteNotification(notification.docStatus, notification.id, userId))
  }

  let iconMarkup
  let infoMarkup
  let buttonMarkup = (
    <Button variant='outline-primary' disabled={disabled} onClick={onNotedClick}>
      Noted
    </Button>
  )

  if (notification)
    switch (notification.docStatus) {
      case 'Pending':
        iconMarkup = <SvgFeather />
        infoMarkup = (
          <p style={{ width: '100%' }}>
            <b className='fa-feather-alt'>"{notification.title}"</b> requires your signature.
          </p>
        )
        break

      case 'Completed':
        iconMarkup = <SvgThumbUp />
        infoMarkup = (
          <p style={{ width: '100%' }}>
            <b className='fa-thumbs-up '>"{notification.title}"</b> is signed and ready.
          </p>
        )
        break

      case 'Rejected':
        iconMarkup = <SvgExclamationMark />
        infoMarkup = (
          <p style={{ width: '100%' }}>
            <b className='fa-exclamation-triangle'>"{notification.title}"</b> is rejected.
          </p>
        )
        break

      case 'Expired':
        iconMarkup = <SvgExpiry />
        infoMarkup = (
          <p style={{ width: '100%' }}>
            <b className='fa-hourglass-end'>"{notification.title}"</b> is expired.
          </p>
        )
        break

      default:
        console.log('wrong notification type')
    }

  let notificationMarkup = notification ? (
    <div className='notification-container'>
      <div className='notification-style' onClick={() => onNotificationClick(notification.id)}>
        <div>{iconMarkup}</div>
        <div className='notification-info'>
          {infoMarkup}
          {notification.createdAt && <p>{moment(notification.createdAt).fromNow()}</p>}
        </div>
      </div>
      {notification.docStatus !== 'Pending' && <div className='notification-button'> {buttonMarkup}</div>}
    </div>
  ) : (
    <div className='notification-style'>
      <SvgCloud />
      <div className='notification-info'>
        <p style={{ width: '100%' }}>You have no notifications right now</p>
      </div>
    </div>
  )

  return <>{notificationMarkup}</>
}

Notification.propTypes = {
  handleNotificationClose: PropTypes.func,
  notification: PropTypes.object,
  userId: PropTypes.string,
}

export default Notification
